"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conciergeUpdateWorkOrderBidRequest = exports.conciergeGetWorkOrderBidRequestById = exports.conciergeGetWorkOrderBidRequestsWithFilters = void 0;
const client_1 = require("@apollo/client");
const fragments_graphql_1 = require("../fragments.graphql");
exports.conciergeGetWorkOrderBidRequestsWithFilters = (0, client_1.gql) `
  ${fragments_graphql_1.WORK_ORDER_FIELDS}
  ${fragments_graphql_1.CONCIERGE_USER_FIELDS}
  ${fragments_graphql_1.ATTACHMENT_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_PRIORITY_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_STATUS_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_ISSUE_TYPE_FIELDS}
  ${fragments_graphql_1.PROPERTY_FIELDS}
  ${fragments_graphql_1.ORGANIZATION_ACCOUNT_FIELDS}
  query conciergeGetWorkOrderBidRequestsWithFilters(
    $status: String
    $workOrderStatusIds: [ID!]
    $assignedConciergeUserId: ID
    $organizationAccountId: ID
    $conciergeVendorId: ID
    $needsReview: Boolean
  ) {
    conciergeGetWorkOrderBidRequestsWithFilters(
      status: $status
      workOrderStatusIds: $workOrderStatusIds
      assignedConciergeUserId: $assignedConciergeUserId
      organizationAccountId: $organizationAccountId
      conciergeVendorId: $conciergeVendorId
      needsReview: $needsReview
    ) {
      id
      status
      createdAt
      assignedConciergeUser {
        ...ConciergeUserFields
      }
      createdByUser {
        id
        firstName
        lastName
        fullName
      }
      workOrder {
        ...WorkOrderFields
        workOrderPriority {
          ...WorkOrderPriorityFields
        }
        workOrderStatus {
          ...WorkOrderStatusFields
        }
        issueType {
          ...WorkOrderIssueTypeFields
        }
        property {
          ...PropertyFields
          organizationAccount {
            ...OrganizationAccountFields
          }
        }
        attachments {
          ...AttachmentFields
        }
      }
    }
  }
`;
exports.conciergeGetWorkOrderBidRequestById = (0, client_1.gql) `
  ${fragments_graphql_1.WORK_ORDER_FIELDS}
  ${fragments_graphql_1.CONCIERGE_USER_FIELDS}
  ${fragments_graphql_1.ATTACHMENT_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_PRIORITY_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_STATUS_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_ISSUE_TYPE_FIELDS}
  ${fragments_graphql_1.PROPERTY_FIELDS}
  ${fragments_graphql_1.ORGANIZATION_ACCOUNT_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONCIERGE_RATINGS_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_PROCURE_RATINGS_FIELDS}
  query conciergeGetWorkOrderBidRequestById($id: ID!) {
    conciergeGetWorkOrderBidRequestById(id: $id) {
      id
      workOrder {
        ...WorkOrderFields
        assignedUser {
          id
          firstName
          lastName
          fullName
        }
        workOrderPriority {
          ...WorkOrderPriorityFields
        }
        workOrderStatus {
          ...WorkOrderStatusFields
        }
        issueType {
          ...WorkOrderIssueTypeFields
        }
        property {
          ...PropertyFields
          organizationAccount {
            ...OrganizationAccountFields
          }
        }
        attachments {
          ...AttachmentFields
        }
      }
      createdByUser {
        id
        firstName
        lastName
        fullName
      }
      assignedConciergeUser {
        ...ConciergeUserFields
      }
      status
      createdAt
      conciergeVendorProcureRatings {
        ...ConciergeVendorProcureRatingFields
      }
      conciergeVendorConciergeRatings {
        ...ConciergeVendorConciergeRatingFields
      }
    }
  }
`;
exports.conciergeUpdateWorkOrderBidRequest = (0, client_1.gql) `
  mutation conciergeUpdateWorkOrderBidRequest($id: ID!, $input: WorkOrderBidRequestUpdateInput!) {
    conciergeUpdateWorkOrderBidRequest(id: $id, input: $input) {
      id
    }
  }
`;
//# sourceMappingURL=work-order-bid-request.queries.graphql.js.map